import axios from "axios"
import appService from "src/AppService"
import { qsStringify } from "src/utilities/helper"
import snackBar from "src/utilities/snackBar/SnackBar"

const secureSession: any = {
    key: null,
    target: null,
    setKey: (key: string) => {
        secureSession.key = key
    },
    cancel: () => {
        const key = secureSession.key
        const target = secureSession.target
        if (key && target) {
            const rb = {
                sessionKey: key,
                TargetView: target
            }
            secureSession.key = null
            secureSession.target = null
            //console.log("canceling secure session")
            axios.post(process.env.REACT_APP_AREA51_BASEURL + "/api/session/cancel", qsStringify(rb), appService.axiosHeaders)
                .catch(err => {
                    //console.log(err)
                })
        } else {
            secureSession.key = null
            secureSession.target = null
        }
    },
    cancelSessionAsync: async () => {
        const key = secureSession.key
        const target = secureSession.target
        if (key && target) {
            const rb = {
                sessionKey: key,
                TargetView: target
            }
            secureSession.key = null
            secureSession.target = null
            try {
                await axios.post(process.env.REACT_APP_AREA51_BASEURL + "/api/session/cancel", qsStringify(rb), appService.axiosHeaders)
            } catch (error) {
                snackBar({ text: "Error Starting Canceling Session", type: "error", timeout: 3000 })
            }
        } else {
            secureSession.key = null
            secureSession.target = null
        }
    }
}
export default secureSession